module.exports = __webpack_public_path__ + "media/images/flags/64/Yemen-f3c12f6684a72fc97a033a54b07ee0cc.png";